// Generated by Melange

import * as Belt__Belt_List from "melange.belt/belt_List.js";
import * as Buhta_landing__ClassifierCard from "./ClassifierCard.js";
import * as Buhta_landing__ClassifiersBank from "./Bank/ClassifiersBank.js";
import * as Buhta_landing__ClassifiersKbk from "./Kbk/ClassifiersKbk.js";
import * as Buhta_landing__ClassifiersKogd from "./Kogd/ClassifiersKogd.js";
import * as Buhta_landing__ClassifiersList from "./ClassifiersList.js";
import * as Buhta_landing__ClassifiersUnit from "./Unit/ClassifiersUnit.js";
import * as Buhta_landing__Route from "../../../Route.js";
import * as Caml_obj from "melange.js/caml_obj.js";
import * as Stdlib__List from "melange/list.js";
import * as JsxRuntime from "react/jsx-runtime";

function ClassifiersPage$RestList(Props) {
  let cards = Props.cards;
  return JsxRuntime.jsx("div", {
    children: Belt__Belt_List.toArray(Stdlib__List.mapi((function (i, card) {
      const Key = String(i);
      return JsxRuntime.jsx(Buhta_landing__ClassifierCard.make, {
        card: card
      }, Key);
    }), cards)),
    className: "mt-10 flex flex-wrap lg:flex-nowrap gap-10 justify-center lg:justify-start"
  });
}

const RestList = {
  make: ClassifiersPage$RestList
};

function ClassifiersPage(Props) {
  const currentRoute = Buhta_landing__Route.ofUrl(Buhta_landing__Route.useUrl(undefined));
  const cards = {
    hd: {
      route: {
        TAG: /* Kogd */ 0,
        _0: /* List */ 0
      },
      bg: "bg-gray-light-landing",
      title: "Коды органов государственных доходов",
      name: "КОГД",
      desc: "Понадобятся при зачислении платежей в бюджет",
      color: "text-white",
      bookmark: "/static/icons/bookmark.svg"
    },
    tl: {
      hd: {
        route: {
          TAG: /* Kbk */ 1,
          _0: /* List */ 0
        },
        bg: "bg-secondary",
        title: "Коды бюджетной классификации",
        name: "КБК",
        desc: "Понадобятся при зачислении платежей в бюджет",
        color: "text-white",
        bookmark: "/static/icons/bookmark.svg"
      },
      tl: {
        hd: {
          route: {
            TAG: /* Bank */ 2,
            _0: /* List */ 0
          },
          bg: "bg-alert",
          title: "Справочник банков",
          name: "Банки",
          desc: "Справочник банков",
          color: "text-white",
          bookmark: "/static/icons/bookmark.svg"
        },
        tl: {
          hd: {
            route: {
              TAG: /* Unit */ 3,
              _0: /* List */ 0
            },
            bg: "bg-divider",
            title: "Классификатор единиц измерения",
            name: "Единицы измерения",
            desc: "Понадобятся при зачислении платежей в бюджет",
            color: "text-black-landing",
            bookmark: "/static/icons/bookmark-black.svg"
          },
          tl: /* [] */ 0
        }
      }
    }
  };
  const filter = function (list, route) {
    return Stdlib__List.filter((function (item) {
      if (/* tag */ typeof route === "number" || typeof route === "string") {
        return false;
      }
      switch (route.TAG) {
        case /* Kogd */ 0 :
          return Caml_obj.caml_notequal(item.route, {
            TAG: /* Kogd */ 0,
            _0: /* List */ 0
          });
        case /* Kbk */ 1 :
          return Caml_obj.caml_notequal(item.route, {
            TAG: /* Kbk */ 1,
            _0: /* List */ 0
          });
        case /* Bank */ 2 :
          return Caml_obj.caml_notequal(item.route, {
            TAG: /* Bank */ 2,
            _0: /* List */ 0
          });
        case /* Unit */ 3 :
          return Caml_obj.caml_notequal(item.route, {
            TAG: /* Unit */ 3,
            _0: /* List */ 0
          });
      }
    }), list);
  };
  let tmp;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
    tmp = null;
  } else {
    const match = currentRoute._2;
    if (/* tag */ typeof match === "number" || typeof match === "string" || match.TAG !== /* Classifiers */ 8) {
      tmp = null;
    } else {
      let tmp$1 = match._0;
      tmp = /* tag */ typeof tmp$1 === "number" || typeof tmp$1 === "string" ? JsxRuntime.jsx("h5", {
          children: "Cобрали все справочники, которые будут вам полезны, в одном месте, сохраняйте эту страницу в закладки для быстрого доступа",
          className: "paragraph-large lg:h5 text-white/40 mt-2 lg:mt-4"
        }) : null;
    }
  }
  let tmp$2;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
    tmp$2 = null;
  } else {
    const match$1 = currentRoute._2;
    if (/* tag */ typeof match$1 === "number" || typeof match$1 === "string" || match$1.TAG !== /* Classifiers */ 8) {
      tmp$2 = null;
    } else {
      let tmp$3 = match$1._0;
      if (/* tag */ typeof tmp$3 === "number" || typeof tmp$3 === "string") {
        tmp$2 = JsxRuntime.jsx(Buhta_landing__ClassifiersList.make, {
          cards: cards
        });
      } else {
        switch (tmp$3.TAG) {
          case /* Kogd */ 0 :
            tmp$2 = JsxRuntime.jsx(Buhta_landing__ClassifiersKogd.make, {});
            break;
          case /* Kbk */ 1 :
            tmp$2 = JsxRuntime.jsx(Buhta_landing__ClassifiersKbk.make, {});
            break;
          case /* Bank */ 2 :
            tmp$2 = JsxRuntime.jsx(Buhta_landing__ClassifiersBank.make, {});
            break;
          case /* Unit */ 3 :
            tmp$2 = JsxRuntime.jsx(Buhta_landing__ClassifiersUnit.make, {});
            break;
        }
      }
    }
  }
  let tmp$4;
  if (/* tag */ typeof currentRoute === "number" || typeof currentRoute === "string" || currentRoute.TAG !== /* Landing */ 0) {
    tmp$4 = null;
  } else {
    const route = currentRoute._2;
    tmp$4 = /* tag */ typeof route === "number" || typeof route === "string" || route.TAG !== /* Classifiers */ 8 ? null : JsxRuntime.jsx(ClassifiersPage$RestList, {
        cards: filter(cards, route._0)
      });
  }
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsx("h3", {
            children: "Справочники",
            className: "h4 lg:h3 text-white"
          }),
          tmp,
          JsxRuntime.jsx("div", {
            children: tmp$2,
            className: "mt-10"
          })
        ],
        className: "w-full lg:w-[1008px]"
      }),
      tmp$4
    ],
    className: "bg-black-landing px-6 lg:px-0 py-16 lg:py-20 flex flex-col items-center"
  });
}

const make = ClassifiersPage;

export {
  RestList,
  make,
}
/* Buhta_landing__ClassifierCard Not a pure module */
